import { Injectable } from '@angular/core';
import Toastify from 'toastify-js';
import { ScreenService } from '../screen/index.js';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	private readonly isMobileView: boolean;

	constructor(screenService: ScreenService) {
		this.isMobileView = screenService.currentScreen().isMobileView;
	}

	open(text: string): void {
		Toastify({
			text: text,
			duration: 3000,
			close: false,
			gravity: this.isMobileView ? 'bottom' : 'bottom', // `top` or `bottom`
			position: this.isMobileView ? 'center' : 'center', // `left`, `center` or `right`
			stopOnFocus: true, // Prevents dismissing of toast on hover,
			className: 'w-notification'
		}).showToast();
	}

	
}
